const selectDeviceAttributes = state => state.data.deviceAttributes

const DeviceAttributeDataStoreSelectors = {
  deviceAttributes: selectDeviceAttributes
}

export default DeviceAttributeDataStoreSelectors
